import { IScheduledPdfCustomReport } from '@/Interfaces/PdfBuilder/ScheduledPdfCustomReport.interface';
import { Button, buttonClasses } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { memo } from 'react';

interface IProps extends GridRenderCellParams<IScheduledPdfCustomReport> {
  onEdit: (report: IScheduledPdfCustomReport) => void;
  onCancel: (id: number) => void;
}

const buttonSx = {
  borderRadius: '32px',
  padding: '4px 12px',
  fontSize: '12px',
  [`& .${buttonClasses.startIcon}`]: { marginRight: '4px' },
};

/**
 + * Memoized actions cell renderer for the scheduled reports grid.
 + * Extracted to prevent unnecessary re-renders when grid data updates.
 + */
const ActionsCell = memo(({ row, onEdit, onCancel }: IProps) => {
  if (!row?.id) return 'N/A';
  return (
    <div className='flex gap-2 justify-center'>
      <Button variant='outlined' onClick={() => onEdit(row)} sx={buttonSx}>
        Edit
      </Button>
      <Button variant='outlined' onClick={() => onCancel(row.id)} sx={buttonSx}>
        Cancel
      </Button>
    </div>
  );
});

export default ActionsCell;
